/* eslint-disable react/no-array-index-key */
import React, { lazy, Suspense, Fragment } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import DashboardLayout from './layouts/DashboardLayout'
import LoadingScreen from './components/LoadingScreen'
import AuthGuard from './components/AuthGuard'
import GuestGuard from './components/GuestGuard'
import TrackingGuestGuard from './components/TrackingGuestGuard'

const routesConfig = [
    {
        exact: true,
        path: '/',
        component: () => <Redirect to="/app/dashboard" />
    },
    {
        exact: true,
        path: '/404',
        component: () => <Redirect to="/" />
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/login',
        component: lazy(() => import('./views/auth/LoginView'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/register',
        component: lazy(() => import('./views/auth/RegisterView'))
    },
    {
        exact: true,
        //guard: TrackingGuestGuard,
        path: '/start',
        component: lazy(() => import('./views/auth/OnboardTrackingView'))
    },
    {
        exact: true,
        guard: AuthGuard,
        path: '/app/surveys/:themeId/editor',
        component: lazy(() => import('./components/ThemeApplication'))
    },
    {
        path: '/',
        guard: AuthGuard,
        layout: DashboardLayout,
        routes: [
            {
                exact: true,
                path: '/app',
                component: () => <Redirect to="/app/dashboard" />
            },
            {
                exact: true,
                path: '/app/dashboard',
                component: lazy(() => import('./views/DashboardView'))
            },
            {
                exact: true,
                path: '/app/analytics',
                component: lazy(() => import('./views/AnalyticsView'))
            },
            {
                exact: true,
                path: '/app/surveys',
                component: lazy(() => import('./views/ThemesView'))
            },
            {
                exact: true,
                path: '/app/reports/funnel',
                component: lazy(() => import('./views/FunnelView'))
            },
            {
                exact: true,
                path: '/app/reports/business',
                component: lazy(() => import('./views/BusinessView'))
            },
            {
                exact: true,
                path: '/app/reports/live',
                component: lazy(() => import('./views/LiveView'))
            },
            {
                exact: true,
                path: '/app/reports/live/:visitorSessionId',
                component: lazy(() => import('./views/LiveSessionView'))
            },
            {
                exact: true,
                path: '/app/reports',
                component: () => <Redirect to="/app/reports/dashboard" />
            },
            {
                exact: true,
                path: '/app/management/containers',
                component: lazy(() => import('./views/QuestionContainerListView'))
            },
            {
                exact: true,
                path: '/app/management/containers/:questionContainerId',
                component: lazy(() => import('./views/QuestionContainerEditView'))
            },
            {
                exact: true,
                path: '/app/management/clients',
                component: lazy(() => import('./views/ClientListView'))
            },
            {
                exact: true,
                path: '/app/management/clients/:clientId',
                component: lazy(() => import('./views/ClientEditView'))
            },
            {
                exact: true,
                path: '/app/management/human-deliveries',
                component: lazy(() => import('./views/HumanDeliveryListView'))
            },
            {
                exact: true,
                path: '/app/management/human-deliveries/:humanDeliveryId',
                component: lazy(() => import('./views/HumanDeliveryEditView'))
            },
            {
                exact: true,
                path: '/app/management/prelanders',
                component: lazy(() => import('./views/PrelanderListView'))
            },
            {
                exact: true,
                path: '/app/management/prelanders/:prelanderId',
                component: lazy(() => import('./views/PrelanderEditView'))
            },
            {
                exact: true,
                path: '/app/management/tracking-tags',
                component: lazy(() => import('./views/TrackingTagListView'))
            },
            {
                exact: true,
                path: '/app/management/tracking-tags/:trackingTagId',
                component: lazy(() => import('./views/TrackingTagEditView'))
            },
            {
                exact: true,
                path: '/app/management/marketing-messages',
                component: lazy(() => import('./views/MarketingMessageListView'))
            },
            {
                exact: true,
                path: '/app/management/marketing-messages/:marketingMessageId',
                component: lazy(() => import('./views/MarketingMessageEditView'))
            },
            {
                exact: true,
                path: '/app/management/marketing-message-templates',
                component: lazy(() => import('./views/MarketingMessageTemplateListView'))
            },
            {
                exact: true,
                path: '/app/management/marketing-message-templates/:marketingMessageTemplateId',
                component: lazy(() => import('./views/MarketingMessageTemplateEditView'))
            },
            {
                exact: true,
                path: '/app/management/import-humans',
                component: lazy(() => import('./views/ImportHumansView'))
            },
            {
                exact: true,
                path: '/app/tools/filesystems',
                component: lazy(() => import('./views/FileSystemView'))
            },
            {
                exact: true,
                path: '/app/tools/export',
                component: lazy(() => import('./views/ExportHumansView'))
            },
            {
                exact: true,
                path: '/app/tools/reports',
                component: lazy(() => import('./views/ReportView'))
            },
            {
                exact: true,
                path: '/app/tools/client-reports',
                component: lazy(() => import('./views/ClientReportsView'))
            },
            {
                exact: true,
                path: '/app/tools/export-requests',
                component: lazy(() => import('./views/ExportRequestsView'))
            },
            {
                exact: true,
                path: '/app/tools/quarantine-processor',
                component: lazy(() => import('./views/QuarantineProcessorView'))
            },
            {
                exact: true,
                path: '/app/tools/white-label',
                component: lazy(() => import('./views/WhiteLabelView'))
            },
            {
                exact: true,
                path: '/app/tools/register-analytics',
                component: lazy(() => import('./views/RegisterAnalyticsView'))
            },
            {
                exact: true,
                path: '/app/tools/pick-a-winner',
                component: lazy(() => import('./views/PickAWinnerView'))
            },
            {
                exact: true,
                path: '/app/system/status',
                component: lazy(() => import('./views/SystemStatusView'))
            },
            {
                exact: true,
                path: '/app/management/campaigns',
                component: lazy(() => import('./views/CampaignListView'))
            },
            {
                exact: true,
                path: '/app/management/campaigns/:campaignId',
                component: lazy(() => import('./views/CampaignEditView'))
            },
            {
                exact: true,
                path: '/app/management/conversion-types/:conversionTypeId',
                component: lazy(() => import('./views/ConversionTypeEditView'))
            },
            {
                exact: true,
                path: '/app/management/deliveries',
                component: lazy(() => import('./views/ConversionDeliveryView'))
            },
            {
                exact: true,
                path: '/app/management/deliveries/:conversionDeliveryEventId',
                component: lazy(() => import('./views/ConversionDeliveryAnalysisView'))
            },
            {
                exact: true,
                path: '/app/management/humans',
                component: lazy(() => import('./views/HumanListView'))
            },
            {
                exact: true,
                path: '/app/tools/visitors',
                component: lazy(() => import('./views/FindVisitorView'))
            },
            {
                exact: true,
                path: '/app/management/invoices',
                component: lazy(() => import('./views/InvoiceListView'))
            },
            {
                exact: true,
                path: '/app/management/credit-notes',
                component: lazy(() => import('./views/CreditNotesListView'))
            },
            {
                component: () => <Redirect to="/404" />
            }
        ]
    }
]

const renderRoutes = routes =>
    routes ? (
        <Suspense fallback={<LoadingScreen />}>
            <Switch>
                {routes.map((route, i) => {
                    const Guard = route.guard || Fragment
                    const Layout = route.layout || Fragment
                    const Component = route.component

                    return (
                        <Route
                            key={i}
                            path={route.path}
                            exact={route.exact}
                            render={props => (
                                <Guard>
                                    <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
                                </Guard>
                            )}
                        />
                    )
                })}
            </Switch>
        </Suspense>
    ) : null

function Routes() {
    return renderRoutes(routesConfig)
}

export default Routes
